import Paper from "@mui/material/Paper";
import {Table, TableCell, TableContainer, TableHead, TableRow, Typography} from "@mui/material";
import TextHelper from "../../../../helpers/textHelper";
import {useDispatch, useSelector} from "react-redux";
import {updateSelectedLines} from "../../../../store/slice/bidComparsionChart";
import {CheckBox} from "@mui/icons-material";
import React from "react";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";

const BidItemRightTable = ({item, rfqDetails}) => {
    const tableCellStyle = {
        borderRight: "1px solid rgba(224, 224,224,1)",
        padding: '6px 8px'
    };
    const selectedSequenceFromWFA = useSelector((state) => state.bidComparsionSlice.selectedSequenceFromWFA)
    const selectedLines = useSelector((state) => state.bidComparsionSlice.selectedLines)
    const chartData = useSelector((state) => state.bidComparsionSlice.comparsionChartData)
    const uniqueObjects = {}
    const headers = item?.bidApprovals?.filter((obj) => {
        if (!uniqueObjects[obj.sequence]) {
            uniqueObjects[obj.sequence] = true;
            return true;
        }
        return false;
    });

    const dispatch = useDispatch()

    const handleChangeCheckBox = (index, i) => {
        const newSelected = {...selectedLines}
        let data = newSelected[index]
        const element = headers?.[i]
        if (data && !data?.rejectReasonId && data?.bidMainId === element?.bidMainId) {
            delete newSelected[index]
        } else {
            data = {
                ...data,
                bidMainId: element?.bidMainId,
                rfqDeatilid: item?.bidDetails?.[index]?.rfqDetailId,
                sequence: selectedSequenceFromWFA,
                approveStatus: element?.approveStatus == 1 ? 0 : 1,
                comment: '',
                rejectReasonId: null
            }
            newSelected[index] = data
        }
        dispatch(updateSelectedLines(newSelected))

    }
    const getCheckStatus = (approvals, index) => {
        const data = selectedLines?.[index]
        if (approvals?.sequence == selectedSequenceFromWFA) {
            return data?.approveStatus == 1 && data?.bidMainId == approvals?.bidMainId && data?.rfqDeatilid == item?.bidDetails?.[index]?.rfqDetailId || approvals?.approveStatus == 1
        }

        return item?.bidApprovals?.filter(x => x?.sequence === approvals?.sequence)?.[index]?.approveStatus == 1
    }

    const checkIsDisabled = (approvals, index, i) => {
        let bidApprovals = [...chartData?.bids?.map(x => x?.bidApprovals)]
        const data = item?.bidApprovals?.filter(item => item?.sequence == 1)
        bidApprovals = [].concat(...bidApprovals)?.filter(x => x?.rfqDetailId === item?.bidDetails?.[index]?.rfqDetailId && x?.sequence < selectedSequenceFromWFA)
        if(data?.[index]?.approveStatus != 1 && i != 0) {
            return true
        }

        if (bidApprovals?.some(x => x?.approveStatus == 2)) {
            return true
        }
        return item?.discualified || approvals?.sequence != selectedSequenceFromWFA
    }

    const handleChangeHeaderCheckBox = (index) => {
        let data = {}
        const selected = Object.values(selectedLines)
        if (selected.length === rfqDetails?.length && headers[index]?.bidMainId == selected[0]?.bidMainId) {
            dispatch(updateSelectedLines({}))
            return
        }
        const newData = item?.bidApprovals?.filter(item => item?.sequence == 1)
        rfqDetails?.forEach((_, i) => {
                if(newData[i]?.approveStatus == 1 || index == 0) {
                    data[i] = {
                        bidMainId: headers[index]?.bidMainId,
                        rfqDeatilid: item?.bidDetails?.[i]?.rfqDetailId,
                        sequence: selectedSequenceFromWFA,
                        approveStatus: 1,
                        comment: '',
                        rejectReasonId: null
                    }
                }
        })
        dispatch(updateSelectedLines({...selectedLines,...data}))
    }

    const headerCheckIsDisabled = (index) => {
        return item?.discualified || headers[index]?.sequence != selectedSequenceFromWFA
    }

    const getHeaderCheckStatus = (index) => {
        const data = Object.values(selectedLines)
        const sequence = headers?.[index]?.sequence
        let bidApprovals = [...chartData?.bids?.map(x => x?.bidApprovals)]
        const length = [].concat(...bidApprovals).filter(x => x?.approveStatus == 2)?.length
        return rfqDetails?.length - length === data?.filter(item => !item?.rejectReasonId && item?.sequence === sequence && item?.bidMainId === headers[index]?.bidMainId)?.length
    }


    return (
        headers?.length > 0 && <TableContainer className="dynamic-checkboxes" style={{borderRadius: 0,borderRight:'1px solid #000'}}
                                               component={Paper}>
            <Table size="small">
                <TableHead>
                    <TableRow style={{height: '55px'}} className="bg-grey">
                        {headers?.map((approvals, index) => (
                            <TableCell style={tableCellStyle} key={index}>
                                <span style={{display: 'flex'}}
                                      className={headerCheckIsDisabled(index) ? '' : 'cursor-pointer'}>
                                            {getHeaderCheckStatus(index) ? (
                                                <CheckBox
                                                    onClick={() => !headerCheckIsDisabled(index) && handleChangeHeaderCheckBox(index)}
                                                    color={headerCheckIsDisabled(index) ? 'muted' : 'primary'}
                                                />
                                            ) : (
                                                <CheckBoxOutlineBlankIcon
                                                    onClick={() => !headerCheckIsDisabled(index) && handleChangeHeaderCheckBox(index)}
                                                    color={headerCheckIsDisabled(index) ? 'muted' : 'primary'}
                                                />
                                            )}
                                       </span>
                            </TableCell>
                        ))}
                    </TableRow>
                    <TableRow style={{height: '49px', maxHeight: '49px'}} className="bg-grey">
                        {headers?.map((approvals, index) => (
                            <TableCell style={tableCellStyle} key={index}>
                                <Typography
                                    sx={{fontWeight: 'bold'}}>{TextHelper.checkTextLength(approvals?.approveStageName, 3, ' ')}</Typography>
                            </TableCell>
                        ))}
                    </TableRow>
                    {rfqDetails?.map((details, index) => (
                        <TableRow className={`${item?.discualified && 'bg-grey'}`} key={index} style={{height: '35px'}}>
                            {headers?.map((approvals, i) => (
                                <TableCell style={tableCellStyle} key={i}>
                                    {item?.bidDetails?.[index] && (
                                        <Tooltip
                                            title={getCheckStatus(approvals, index) ? 'Approved' : 'Approve'}>
                                            <IconButton style={{padding: '2px'}}>
                                                    <span style={{display: 'flex'}}
                                                          className={checkIsDisabled(approvals, index,i) ? '' : 'cursor-pointer'}>
                                            {getCheckStatus(approvals, index) ? (
                                                <CheckBox
                                                    color={checkIsDisabled(approvals, index,i) ? 'muted' : 'primary'}
                                                    onClick={() => !checkIsDisabled(approvals, index,i) && handleChangeCheckBox(index, i)}/>
                                            ) : (
                                                <CheckBoxOutlineBlankIcon
                                                    color={checkIsDisabled(approvals, index,i) ? 'muted' : 'primary'}
                                                    onClick={() => !checkIsDisabled(approvals, index,i) && handleChangeCheckBox(index, i)}/>
                                            )}
                                       </span>
                                            </IconButton>
                                        </Tooltip>
                                    )}
                                </TableCell>
                            ))}
                        </TableRow>
                    ))}
                    <TableRow className="bg-grey" style={{height: '13px'}}>
                        {Array.from({length: headers.length}).map((_, index) => (
                            <TableCell style={tableCellStyle} key={index}/>
                        ))}
                    </TableRow>
                </TableHead>
            </Table>
        </TableContainer>
    )
}

export default BidItemRightTable
